<surf-header
  class="l-page__header"
  [emulationInProgress]="emulationInProgress"
  [emulatingUser]="emulatingTradeClient"
  [isStartEmulationOptionAvailable]="true"
  [enableCacheUrlRedirect]="true"
  [enableCurrencyDropDown]="ENABLE_B2B_HEADER_CURRENCY_DROPDOWN"
  (startStopEmulation)="startStopEmulation($event)"
  (onSelectBrand)="selectBrand($event)"
  (openAndCloseSurfClientSearchModal)="openAndCloseSurfClientSearchModal($event)"
  (onSelectCurrency)="selectCurrency($event)"
  (openAndCloseSurfBannerModal)="openAndCloseSurfBannerModal($event)"

></surf-header>

<main class="l-page__main">
  <!--  -->
  <section class="dashboard" *ngIf="!enableDashboardDetailView && !enableTariffView">
    <div [ngStyle]="{'background-image': !activeSearchFlow && ENABLE_DASHBOARD_HIGHLIGHTS_COLLAPSED_VIEW ? 'url(' + currentImageUrl + ')' : '' }"
    [ngClass]="
        !activeSearchFlow && ENABLE_DASHBOARD_HIGHLIGHTS_COLLAPSED_VIEW
          ? 'dashboard__search'
          : 'dashboard__search-block'
      "
    >
      <div
        [ngClass]="
          !activeSearchFlow && ENABLE_DASHBOARD_HIGHLIGHTS_COLLAPSED_VIEW
            ? 'l-wrapper dashboard__search-wrapper'
            : 'l-wrapper dashboard__search-block-wrapper'
        "
      >
        <ng-container>
          <div [ngClass]="{'dashboard__search-container':showSearchBar}">
            <div class="dashboard__search-bar">
              <!-- c-search-navbar -->
              <surf-search-panel
                [isAllowedUser]="checkUserIsEmulatedClient()"
                (searchFlow)="selectSearchFlow($event)"
              ></surf-search-panel>
            </div>
            <div class="dashboard__search-box" *ngIf="showSearchBar" [class.dashboard__search-box--restricted]="!canUserViewBookings()">
              <surf-linking-itineraries
                [loadAllResultsAsDefault]="true"
                [isLinkItinerary]="false"
                (popupClosed)="resetSelectedOption()"
                (goToDetailsView)="goToDetailsView()"
                [enableTariffButton]="ENABLE_SURF_TARIFF"
                (tariffButtonClick)="goToTariffView()"
              ></surf-linking-itineraries>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!activeSearchFlow">
          <div class="dashboard__promo-col"></div>
        </ng-container>
      </div>
    </div>

    <div *ngIf="activeSearchFlow == 'PKG'" class="dashboard__search-expand">
      <div class="l-wrapper">
        <surf-package-criteria></surf-package-criteria>
      </div>
    </div>

    <div *ngIf="activeSearchFlow == 'HTL'" class="dashboard__search-expand">
      <div class="l-wrapper">
        <surf-hotel-criteria-dp
          [isDPSearch]="false"
          [setRoomWise]="ENABLE_ROOM_WISE"
        ></surf-hotel-criteria-dp>
      </div>
    </div>

    <div *ngIf="activeSearchFlow == 'TRS'" class="dashboard__search-expand">
      <div class="l-wrapper">
        <surf-transfer-criteria-dp
          [isDPSearch]="false"
        ></surf-transfer-criteria-dp>
      </div>
    </div>

    <div *ngIf="activeSearchFlow == 'TOU'" class="dashboard__search-expand">
      <div class="l-wrapper">
        <surf-tour-criteria-dp
          [keyControls]="getKeyControls()"
        ></surf-tour-criteria-dp>
      </div>
    </div>

    <div *ngIf="activeSearchFlow == 'GEN'" class="dashboard__search-expand">
      <div class="l-wrapper">
        <surf-generic-criteria-dp></surf-generic-criteria-dp>
      </div>
    </div>

    <surf-add-manual-item
      [isActive]="activeSearchFlow == 'MAN'"
      [keyControls]="getKeyControls()"
    ></surf-add-manual-item>

    <surf-add-manual-booking-item
      *ngIf="showManualItemConfig || showManualItemConfigPnr"
      [isActive]="
        activeSearchFlow == 'MANFLT' ||
        activeSearchFlow == 'MAN_CRU' ||
        showManualItemConfigPnr
      "
      [productCode]="showManualItemConfigPnr ? 'FLT' : activeMBIProductCode"
      [isDashboard]="true"
      [pnrComponentOutput]="pnrComOutput"
      [flightGrabPnrResult]="flightGrabPnrResult"
      [isPnr]="showManualItemConfigPnr"
      [keyControls]="getKeyControls()"
      [changePassengersEnabled]="showManualItemConfigPnr ? false : true"
      (emitOnClose)="setManualItemConfigPnr(!$event)"
    >
    </surf-add-manual-booking-item>
    <surf-add-insurance
      *ngIf="showManualItemConfig"
      [isFromDashBoard]="true"
      [keyControls]="getKeyControls()"
      [isActive]="activeSearchFlow == 'INS'"
      [productCode]="'INS'"
      [changePassengersEnabled]="true"
    ></surf-add-insurance>

    <surf-booking-summary
      *ngIf="
        !ENABLE_DASHBOARD_HIGHLIGHTS_COLLAPSED_VIEW && activeSearchFlow === null
      "
      (onSelectedDurationChanged)="setBookingSearchInputFocus()"
      (onToggleRetailStoreViewStatus)="onToggleRetailStoreViewStatus($event)"
    ></surf-booking-summary>

    <div class="dashboard__section" *ngIf="!activeSearchFlow && promoRecommendationList.length">
      <div class="l-wrapper dashboard__section-wrapper">
        <h2 class="dashboard__section-title">Book Our Top Recommended Hotels, Tours, & Activities</h2>
        <div class="dashboard__slider">
          <surf-recommendation-slider
            [recommendationList]="promoRecommendationList"
            [rotationTime]="SURF_LANDING_CAROUSEL_SLIDE_INTERVAL"
            [openInNewTab]="SURF_RECOMMENDATION_OPEN_IN_NEW_TAB"
          ></surf-recommendation-slider>
        </div>
      </div>
    </div>
  </section>

  <section class="dashboard" *ngIf="enableDashboardDetailView">
    <surf-toaster-notification
      [hasConfirmButton]="true"
      [hasCancelButton]="true"
      [hasDuration]="false"
      [confirmLabel]="'View Quote'"
      [cancelLabel]="'Dismiss'"
      [duration]="10000"
      [message]="'Quote is successfully saved.'"
      [shortMessage]="'Quote ID ' + bkgId"
      [active]="activeToaster"
      (actionItem)="onclickActionItem($event)"
    ></surf-toaster-notification>
    <surf-booking-summary
      (goToDashboardDetailsView)="backToLandingView()"
    ></surf-booking-summary>
  </section>

  <section class="dashboard" *ngIf="enableTariffView">
      <surf-tariff-search
      (goBack)="backToLandingView()"
      >
      </surf-tariff-search>
  </section>
</main>

<surf-modal
  [active]="isSurfClientSearchModalActive"
  [contentClass]="'c-client-search_modal'"
  [hasCancelButton]="false"
  [hasConfirmButton]="false"
  [disableConfirm]="false"
  (clickButton)="handleSurfClientSearchModal($event)"
>
  <surf-client-search-modal
    (openAndCloseSurfClientSearchModal)="
      openAndCloseSurfClientSearchModal($event)
    "
    (selectClient)="selectTheEmulatingClient($event)"
  >
  </surf-client-search-modal>
</surf-modal>
<surf-modal
  [active]="isSurfBannerModalActive"
  [contentClass]="'c-client-search_modal'"
  [hasCancelButton]="false"
  [hasConfirmButton]="false"
  [disableConfirm]="false"
  (clickButton)="handleSurfClientSearchModal($event)"
>
</surf-modal>

<!-- Emulation warning message box -->
<surf-message-box
  [title]="'Please Note'"
  [active]="activeEmulationWarning"
  [hasConfirmButon]="true"
  [hasCancelButton]="true"
  [confirmLabel]="'Proceed'"
  [cancelLabel]="'Cancel'"
  [svgName]="'exclamation'"
  [type]="'warning'"
  (clickButton)="handleEmulationWarning($event)"
>
  <span>{{ EmulationWarningText | surfTextCase : "sentence" }}</span>
</surf-message-box>

<surf-message-box
  [title]="'Please Note'"
  [active]="activeCreditLimitWarning"
  [hasConfirmButon]="true"
  [hasCancelButton]="true"
  [confirmLabel]="'Proceed'"
  [cancelLabel]="'Logout'"
  [svgName]="'info'"
  [type]="'warning'"
  (clickButton)="handleCreditLimitWarningAction($event)"
>
  <span>{{ creditLimitWarningMessage | surfTextCase : "sentence" }}</span>
</surf-message-box>
<app-chat-panel *ngIf="enableSurfChatBotWidget"></app-chat-panel>
<surf-footer [version]="version"></surf-footer>

